import { toPng, toSvg } from 'html-to-image'

export const convertHTMLToImage = async (
  elementId: string,
  type: 'png' | 'svg' = 'png'
) => {
  const chartElement = document.getElementById(elementId)
  if (!chartElement) return null

  try {
    if (type === 'svg') {
      return await toSvg(chartElement)
    } else {
      return await toPng(chartElement)
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error converting chart to image:', error)
    return null
  }
}
